import {getStats} from '@/api/admin';
import {useQuery} from '@tanstack/react-query';

export function useAdminStats() {
    return useQuery({
        queryKey: ['admin', 'stats'],
        queryFn: getStats,
        staleTime: 30 * 1000
    });
}
